import { SELECIONAR_ENDERECO } from '../types'

export default function selecionarEndereco (endereco) {
  return {
    type: SELECIONAR_ENDERECO,
    payload: endereco
  }
}
